module.exports = __webpack_public_path__ + "img/weixin.e0a03a2d.png";